import React, { Fragment, useState, useEffect } from "react";
import { Link , useNavigate} from "react-router-dom";
// import DatePicker from "react-datepicker";
import useRequests from "../../../utils/useRequests";
import "react-datepicker/dist/react-datepicker.css";
import { Card, Form, Spinner, Button, Modal } from "react-bootstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../../utils/Snackbars";
import {Typography, Grid, FormControl} from '@mui/material';
import DatePicker from "react-datepicker";
import calender from "../../../images/calender.png"

const AddOrgTicket = () => {
    const navigate = useNavigate();
    const { getRequest, postRequest } = useRequests();

    const [duration, setduration] = useState("");
    const [isSeatsRequired, setIsSeatsRequired] = useState(false);
    const [availableSeats, setAvailableSeats] = useState([]);
    const [selectedSeats, setSelectedSeats] = useState([]);
    const [seatInterval, setSeatInterval] = useState(null);

  const [isProcessing, setIsProcessing] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const handleOpenModal = () => {
      setShowModal(true);
    };
    const handleCloseModal = () => {
      if (!isProcessing) {
        setShowModal(false);
      }
    };
      
    const [formData, setFormData] = useState({
        e_id: "",
        e_t_id: "",
        u_id: "",
        ticket_quantity: "1",
        date: "",
        selected_seats: []
    });
    
    const [AlertData, setAlertData] = React.useState({
           variant: '',
           message: '',
         });
       
    const resetAlertData = () => {
        setTimeout(() => {
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: '',
                message: '',
            }));
        }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
    };

    function formatDateToUTC(dateString) {
        let date = new Date(dateString);
    
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, "0");
        let day = String(date.getDate()).padStart(2, "0");
    
        return new Date(`${year}-${month}-${day}T00:00:00.000Z`).toISOString();
    }

    function formatDate(dateString) {
        let date = new Date(dateString);
    
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, "0");
        let day = String(date.getDate()).padStart(2, "0");
    
        return `${year}-${month}-${day}`;
    }

    // Fetch seat availability
    const fetchSeatAvailability = async (e_id, e_t_id, date) => {
        if (!e_id || !e_t_id || !date) return;
        
        try {
            const formattedDate = formatDate(date);
            const response = await getRequest(`seat-availability-with-conflicts/${e_id}/${e_t_id}/${formattedDate}`);
            if (response && response.code === 200) {
                const data = response.data;
                
                // Create a map to track seat status
                const seatStatusMap = new Map();
                
                // Mark available seats
                if (data.available_seat_list && data.available_seat_list.length > 0) {
                    data.available_seat_list.forEach(seatNumber => {
                        seatStatusMap.set(seatNumber, {
                            seat_id: seatNumber,
                            seat_number: seatNumber,
                            is_available: 'Yes',
                            status: 'available'
                        });
                    });
                }
                
                // Mark booked seats
                if (data.booked_seat_list && data.booked_seat_list.length > 0) {
                    data.booked_seat_list.forEach(seatNumber => {
                        seatStatusMap.set(seatNumber, {
                            seat_id: seatNumber,
                            seat_number: seatNumber,
                            is_available: 'No',
                            status: 'booked'
                        });
                    });
                }
                
                // Mark conflict seats
                if (data.conflict_seat_list && data.conflict_seat_list.length > 0) {
                    data.conflict_seat_list.forEach(seatNumber => {
                        seatStatusMap.set(seatNumber, {
                            seat_id: seatNumber,
                            seat_number: seatNumber,
                            is_available: 'No',
                            status: 'conflict'
                        });
                    });
                }
                
                // Create final seat array using total_seat_list to ensure all seats are included
                const allSeats = [];
                if (data.total_seat_list && data.total_seat_list.length > 0) {
                    data.total_seat_list.forEach(seatNumber => {
                        const seatInfo = seatStatusMap.get(seatNumber);
                        if (seatInfo) {
                            allSeats.push(seatInfo);
                        } else {
                            // If seat is not in any list, mark as unavailable
                            allSeats.push({
                                seat_id: seatNumber,
                                seat_number: seatNumber,
                                is_available: 'No',
                                status: 'unavailable'
                            });
                        }
                    });
                } else {
                    // Fallback: use seats from status map if total_seat_list is not available
                    seatStatusMap.forEach((seatInfo) => {
                        allSeats.push(seatInfo);
                    });
                }
                
                // Sort seats by seat number for better display
                allSeats.sort((a, b) => {
                    // Extract row and number from seat (e.g., "A1" -> row: "A", num: 1)
                    const parseSeata = a.seat_number.match(/([A-Z]+)(\d+)/);
                    const parseSeatb = b.seat_number.match(/([A-Z]+)(\d+)/);
                    
                    if (parseSeata && parseSeatb) {
                        const rowA = parseSeata[1];
                        const numA = parseInt(parseSeata[2]);
                        const rowB = parseSeatb[1];
                        const numB = parseInt(parseSeatb[2]);
                        
                        // First sort by row, then by number
                        if (rowA !== rowB) {
                            return rowA.localeCompare(rowB);
                        }
                        return numA - numB;
                    }
                    
                    return a.seat_number.localeCompare(b.seat_number);
                });
                
                setAvailableSeats(allSeats);
            } else {
                console.error("Failed to fetch seat availability:", response?.message);
                setAvailableSeats([]);
            }
        } catch (error) {
            console.error("Error fetching seat availability:", error);
            setAvailableSeats([]);
        }
    };

    const validation1 = useFormik({
        enableReinitialize: true,

        initialValues: formData,
        validationSchema: Yup.object({
          e_id: Yup.string().required("Plsease select Event"),
          e_t_id: Yup.string().required("Plsease select Ticket Type"),
          u_id: Yup.string().required("Plsease select User"),
          ticket_quantity: Yup.number()
          .min(1, "Minimum 1 ticket required")
          .max(6, "Maximum 6 tickets allowed")
          .required("Please select Ticket quantity"),
          date: Yup.string().test(
            "required-if-duration-1",
            "Please select Date",
            function (value) {
              if (duration == 1) {
                return !!value; 
              }
              return true; 
            }
          ),
          selected_seats: Yup.array().when('ticket_quantity', {
            is: (ticket_quantity) => isSeatsRequired && ticket_quantity,
            then: Yup.array().test(
              'seats-match-quantity',
              'Number of selected seats must match ticket quantity',
              function(value) {
                const quantity = parseInt(this.parent.ticket_quantity) || 0;
                return value && value.length === quantity;
              }
            ),
            otherwise: Yup.array()
          })
        }),

        
    onSubmit: async (values) => {
        if(showModal == false){
          setShowModal(true);
          return;
        }
        try {
            let submit1 = document.getElementById('submit1');
            submit1.disabled = true;
            submit1.textContent = ('Processing...');

            let submit2 = document.getElementById('submit2');
            submit2.textContent = ('Processing...');
            submit2.disabled = true; // Also disable the modal button
            setIsProcessing(true);

            // Convert form data to JSON
            const payload = {
              e_id: values.e_id,
              e_t_id: values.e_t_id,
              u_id: values.u_id,
              ticket_quantity: values.ticket_quantity,
              // If duration is 1 day, use selected date; if 10 days, use current date
              date: duration === 1 
                ? (values.date ? formatDateToUTC(values.date) : "") 
                : formatDateToUTC(new Date()),
              event_date: parseInt(duration) === 1
                ? (values.date ? formatDate(values.date) : "")
                : formatDate(new Date()),
            };

            // Add selected seats if seats are required
            if (isSeatsRequired && selectedSeats.length > 0) {
                payload.selected_seats = selectedSeats;
            }

            const jsonpar = JSON.stringify(payload);

            // Make the POST request
            const res = await postRequest("assign-ticket", jsonpar);

            // Handle the response
            if (res && res.code === 200) {
                setFormData({
                  e_id: "",
                  e_t_id: "",
                  u_id: "",   
                  ticket_quantity: "1",   
                  date: "",
                  selected_seats: []
                });
                setSelectedSeats([]);
                // Close modal on success
                setShowModal(false);
                navigate('/list-org-tickets',{
                    state:{variant: "success",
                        message: "Ticket assigned successfully!",}
                })
            } else {
                setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: res.message || "Failed to assign ticket.",
                  }));
                  resetAlertData();
            }
            
            // Reset button states
            submit1.disabled = false;
            submit1.textContent = ('Assign Ticket');
            submit2.textContent = ('Assign');
            submit2.disabled = false;
        } catch (error) {
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'error',
                message: "An error occurred while assigning ticket",
              }));
              resetAlertData();
        } finally {
          // Reset button states on error
          let submit1 = document.getElementById('submit1');
          let submit2 = document.getElementById('submit2');
          submit1.disabled = false;
          submit1.textContent = ('Assign Ticket');
          submit2.textContent = ('Assign');
          submit2.disabled = false;
          setIsProcessing(false);
        }
    }
    });

    // Handle seat selection
    const handleSeatSelection = (seatId) => {
        const maxSeats = parseInt(validation1.values.ticket_quantity) || 1;
        
        if (selectedSeats.includes(seatId)) {
            // Remove seat
            const newSelectedSeats = selectedSeats.filter(id => id !== seatId);
            setSelectedSeats(newSelectedSeats);
            validation1.setFieldValue("selected_seats", newSelectedSeats);
        } else {
            // Add seat if under limit
            if (selectedSeats.length < maxSeats) {
                const newSelectedSeats = [...selectedSeats, seatId];
                setSelectedSeats(newSelectedSeats);
                validation1.setFieldValue("selected_seats", newSelectedSeats);
            } else {
                setAlertData({
                    variant: 'warning',
                    message: `You can only select ${maxSeats} seat(s)`,
                });
                resetAlertData();
            }
        }
    };

    // Clear interval when component unmounts or when seats are not required
    useEffect(() => {
        return () => {
            if (seatInterval) {
                clearInterval(seatInterval);
            }
        };
    }, [seatInterval]);

    // Set up seat availability polling
    useEffect(() => {
        if (isSeatsRequired && validation1.values.e_id && validation1.values.e_t_id) {
            // For 1 day tickets, need a selected date
            // For 10 day tickets, use current date
            let dateToUse;
            let shouldFetch = false;
            
            if (parseInt(duration) === 1) {
                // For 1-day tickets, only fetch if date is selected
                if (validation1.values.date) {
                    dateToUse = validation1.values.date;
                    shouldFetch = true;
                } else {
                    // Clear seats if no date is selected for 1-day tickets
                    setAvailableSeats([]);
                    shouldFetch = false;
                }
            } else {
                // For 10-day tickets, use current date
                dateToUse = new Date();
                shouldFetch = true;
            }
            
            if (shouldFetch && dateToUse) {
                // Initial fetch
                fetchSeatAvailability(validation1.values.e_id, validation1.values.e_t_id, dateToUse);
                
                // Set up interval for every 15 seconds
                const interval = setInterval(() => {
                    fetchSeatAvailability(validation1.values.e_id, validation1.values.e_t_id, dateToUse);
                }, 15000);
                
                setSeatInterval(interval);
                
                return () => clearInterval(interval);
            } else {
                // Clear interval and seats when conditions are not met
                if (seatInterval) {
                    clearInterval(seatInterval);
                    setSeatInterval(null);
                }
            }
        } else {
            // Clear interval and seats when seats are not required
            if (seatInterval) {
                clearInterval(seatInterval);
                setSeatInterval(null);
            }
            setAvailableSeats([]);
        }
    }, [isSeatsRequired, validation1.values.e_id, validation1.values.e_t_id, validation1.values.date, duration]);

    // Clear selected seats when quantity changes
    useEffect(() => {
        const maxSeats = parseInt(validation1.values.ticket_quantity) || 1;
        if (selectedSeats.length > maxSeats) {
            const newSelectedSeats = selectedSeats.slice(0, maxSeats);
            setSelectedSeats(newSelectedSeats);
            validation1.setFieldValue("selected_seats", newSelectedSeats);
        }
    }, [validation1.values.ticket_quantity]);

    const [eventStartDate, setEventStartDate] = useState(); 
    const [eventEndDate, setEventEndDate] = useState(); 

    const [options, setOptions] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(); 
    const handleSelectChange = (event) => {
      // Clear seats when event changes
      setSelectedSeats([]);
      validation1.setFieldValue("selected_seats", []);
      validation1.setFieldValue("date", "");
      validation1.setFieldValue("e_id", event.target.value);
      setSelectedEvent(event.target.value); 

      const Event = events.filter((e) => event.target.value == e.e_id);

      setEventStartDate(Event[0].start_datetime)
      setEventEndDate(Event[0].end_datetime)

      let optionsData=[];
      if (Event[0].one_day_ticket) optionsData.push({ value: "1", label: "1 Day" });
      if (Event[0].ten_day_ticket) optionsData.push({ value: "10", label: "10 Days" });
      setOptions(optionsData)
      setduration(optionsData[0].value)

      let eventTicketType = alleventsTicketTypes.filter((type) => type.e_id == event.target.value && type.day_pass == optionsData[0].value);

      if (optionsData[0].value === "1") {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        const startDate = new Date(Event[0].start_datetime);
        startDate.setHours(0, 0, 0, 0);
        
        // If start_datetime > today, use start_datetime; otherwise use today + 1
        let dateToUse;
        if (startDate > today) {
            dateToUse = new Date(Event[0].start_datetime);
        } else {
            dateToUse = new Date(today);
        }
        
        const dateToUseString = dateToUse.toISOString().split('T')[0];
        
        eventTicketType = eventTicketType.filter((type) => {
            const dayDate = new Date(type.day_date);
            const dayDateString = dayDate.toISOString().split('T')[0];
            return dayDateString === dateToUseString;
        });
        
        validation1.setFieldValue("date", dateToUse);
      }
      
      setParticularEventTicketType(eventTicketType);

      if (eventTicketType.length > 0) {
        validation1.setFieldValue("e_t_id", eventTicketType[0].e_t_id);
        setSelectedTicketType(eventTicketType[0].e_t_id);
      }
      else {
        validation1.setFieldValue("e_t_id", "");
        setSelectedTicketType("");
      }
      validation1.setFieldValue("ticket_quantity", 1);

      // Check if seats are required for this event
      setIsSeatsRequired(Event[0].is_seats_required === 'Yes');
    };

    const [selectedTicketType, setSelectedTicketType] = useState(); 
    const handleSelectChangeTicketType = (type) => {
      // Clear seats when ticket type changes
      setSelectedSeats([]);
      validation1.setFieldValue("selected_seats", []);
      validation1.setFieldValue("e_t_id", type.target.value);
      setSelectedTicketType(type.target.value); 
    };

    const handleSelectChangeDuration = (duration) => {
      // Clear seats when duration changes
      setSelectedSeats([]);
      validation1.setFieldValue("selected_seats", []);
      setduration(duration.target.value); 

      let eventTicketType = alleventsTicketTypes.filter((type) => type.e_id == selectedEvent && type.day_pass == duration.target.value);

      // Auto-fill the selectedDate with start_datetime
      if (duration.target.value === "1") {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        const startDate = new Date(eventStartDate);
        startDate.setHours(0, 0, 0, 0);
        
        // If start_datetime > today, use start_datetime; otherwise use today + 1
        let dateToUse;
        if (startDate > today) {
            dateToUse = new Date(eventStartDate);
        } else {
            dateToUse = new Date(today);
        }
        
        const dateToUseString = dateToUse.toISOString().split('T')[0];
        
        eventTicketType = eventTicketType.filter((type) => {
            const dayDate = new Date(type.day_date);
            const dayDateString = dayDate.toISOString().split('T')[0];
            return dayDateString === dateToUseString;
        });
        
        validation1.setFieldValue("date", dateToUse);
      }
      
      setParticularEventTicketType(eventTicketType);

      if (eventTicketType.length > 0) {
        validation1.setFieldValue("e_t_id", eventTicketType[0].e_t_id);
        setSelectedTicketType(eventTicketType[0].e_t_id);
      }
      else {
        validation1.setFieldValue("e_t_id", "");
        setSelectedTicketType("");
      }
      validation1.setFieldValue("ticket_quantity", 1);
    };

    const handleDateChange = (date) => {
        validation1.setFieldValue("date", date);
        // Clear seats when date changes
        setSelectedSeats([]);
        validation1.setFieldValue("selected_seats", []);
        
        if (duration === "1" && date) {
            const selectedDateString = date.toISOString().split('T')[0]; // Convert to YYYY-MM-DD format
            
            // Filter tickets based on the selected date
            let filteredEventTicketType = alleventsTicketTypes.filter((type) => {
                if (type.e_id == selectedEvent && type.day_pass == "1") {
                    const dayDate = new Date(type.day_date);
                    const dayDateString = dayDate.toISOString().split('T')[0];
                    return dayDateString === selectedDateString;
                }
                return false;
            });
            
            setParticularEventTicketType(filteredEventTicketType);
            
            if (filteredEventTicketType.length > 0) {
                validation1.setFieldValue("e_t_id", filteredEventTicketType[0].e_t_id);
                setSelectedTicketType(filteredEventTicketType[0].e_t_id);
            } else {
                // Handle case when no tickets match the criteria
                validation1.setFieldValue("e_t_id", "");
                setSelectedTicketType("");
            }
            validation1.setFieldValue("ticket_quantity", 1);
        }
    };

    const [events, setEvents] = useState([]);
    const [alleventsTicketTypes, setAllEventsTicketTypes] = useState([]);
    const [particularEventTicketType, setParticularEventTicketType] = useState([]);

    const fetchEvents = async () => {
      const response = await getRequest("event-list");
      if (response && response.code === 200) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        let eventsData = [];
        response.data.data.forEach((element) => {
          if (element.status == "Enable" && new Date(element.end_datetime) >= today) {
            eventsData.push(element);
          }
        });
        setEvents(eventsData);
        setAllEventsTicketTypes( response.data.eventTicketTypeData);

        if(eventsData.length !== 0){
          validation1.setFieldValue("e_id", eventsData[0].e_id);
          setSelectedEvent(eventsData[0].e_id); 
          setEventStartDate(eventsData[0].start_datetime)
          setEventEndDate(eventsData[0].end_datetime)

          // Check if seats are required for the first event
          setIsSeatsRequired(eventsData[0].is_seats_required === 'Yes');

          let optionsData=[];
          if (eventsData[0].one_day_ticket) optionsData.push({ value: "1", label: "1 Day" });
          if (eventsData[0].ten_day_ticket) optionsData.push({ value: "10", label: "10 Days" });

          if(optionsData.length !==0){
            setOptions(optionsData)
            setduration(optionsData[0].value)

            let eventTicketType = response.data.eventTicketTypeData.filter((type) => type.e_id == eventsData[0].e_id && type.day_pass == optionsData[0].value);
                    
            // Additional filter when duration is "1" - filter by day_date matching start_date
            if (optionsData[0].value === "1") {
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              
              const startDate = new Date(eventsData[0].start_datetime);
              startDate.setHours(0, 0, 0, 0);
              
              // If start_datetime > today, use start_datetime; otherwise use today + 1
              let dateToUse;
              if (startDate > today) {
                  dateToUse = new Date(eventsData[0].start_datetime);
              } else {
                  dateToUse = new Date(today);
              }
              
              const dateToUseString = dateToUse.toISOString().split('T')[0];
              
              eventTicketType = eventTicketType.filter((type) => {
                  const dayDate = new Date(type.day_date);
                  const dayDateString = dayDate.toISOString().split('T')[0];
                  return dayDateString === dateToUseString;
              });
              
              validation1.setFieldValue("date", dateToUse);
            }

            setParticularEventTicketType(eventTicketType);

            if (eventTicketType.length > 0) {
                validation1.setFieldValue("e_t_id", eventTicketType[0].e_t_id);
                setSelectedTicketType(eventTicketType[0].e_t_id);
            }
            else {
              validation1.setFieldValue("e_t_id", "");
              setSelectedTicketType("");
            }
            validation1.setFieldValue("ticket_quantity", 1);
          }
          else{
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: 'Tickets are not available',
            }));
          }
        }
        
        
        } else {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: 'Failed to fetch events',
        }));
      }
      resetAlertData();
    };

    const [selectedUser, setSelectedUser] = useState(""); 
    const [username, setUsername] = useState(""); 
    const handleSelectChangeUser = (user) => {
      validation1.setFieldValue("u_id", user.target.value);
      users.forEach(element => {
        if(element.u_id==user.target.value){
          setUsername(element.phone)
        }
      });
      
      setSelectedUser(user.target.value); 
    };

    const [users, setUsers] = useState([]);
    const fetchUsers = async () => {
      const response = await getRequest("user-list");
      if (response && response.code === 200) {
        let usersData = [];
        response.data.forEach((element) => {
          if (element.status == "Enable") {
            usersData.push(element);
          }
        });

        setUsers(usersData);
      } else {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: 'Failed to fetch users',
        }));
      }
      resetAlertData();
    };

    useEffect(() => {
      fetchEvents();
      fetchUsers();
      resetAlertData();
    }, []);

    return (
      <Fragment>
        <div className='d-sm-flex d-block justify-content-between align-items-center mb-4'>
          <h2 className='text-black font-w700 mb-0'>Assign Ticket</h2>
        </div>

        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='basic-form'>
                {AlertData.message !== "" ? (
                  <Snackbars
                    variant={AlertData.variant}
                    message={AlertData.message}
                  />
                ) : (
                  ""
                )}
                <form>
                  <div className='row mb-3'>

                    
                  <div className="form-group mb-3 col-md-4 col-xs-12">
                    <label>Select User :</label>
                    <select
                      className={`form-control ${
                        validation1.touched.u_id && validation1.errors.u_id
                          ? "is-invalid"
                          : ""
                      }`}
                      name="u_id"
                      value={validation1.values.u_id}
                      onChange={handleSelectChangeUser}
                    >
                      <option value="">-- Select User --</option>
                      {users.map((user) => (
                        <option key={user.u_id} value={user.u_id}>
                          {user.phone}
                        </option>
                      ))}
                    </select>
                    {validation1.touched.u_id && validation1.errors.u_id && (
                      <div className="invalid-feedback">
                        {validation1.errors.u_id}
                      </div>
                    )}
                  </div>

                  <div className="form-group mb-3 col-md-4 col-xs-12">
                    <label>Select Event :</label>
                    <select
                      className={`form-control ${
                        validation1.touched.e_id && validation1.errors.e_id
                          ? "is-invalid"
                          : ""
                      }`}
                      name="e_id"
                      value={validation1.values.e_id}
                      onChange={handleSelectChange}
                    >
                      <option value="">-- Select Event --</option>
                      {events.map((event) => (
                        <option key={event.e_id} value={event.e_id}>
                          {event.name}
                        </option>
                      ))}
                    </select>
                    {validation1.touched.e_id && validation1.errors.e_id && (
                      <div className="invalid-feedback">
                        {validation1.errors.e_id}
                      </div>
                    )}
                  </div>


                  <div className="form-group mb-3 col-md-4 col-xs-12">
                    <label>Select Pass Duration :</label>
                    <select
                      className={'form-control'}
                      name="duration"
                      onChange={handleSelectChangeDuration}
                    >
                      {options.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group mb-3 col-md-4 col-xs-12">
                    <label>Select Ticket Type :</label>
                    <select
                      className={`form-control ${
                        validation1.touched.e_t_id && validation1.errors.e_t_id
                          ? "is-invalid"
                          : ""
                      }`}
                      name="e_t_id"
                      value={validation1.values.e_t_id}
                      onChange={handleSelectChangeTicketType}
                    >
                      <option value="">-- Select TicketType --</option>
                      {particularEventTicketType.map((ticketTypes) => (
                        <option key={ticketTypes.e_t_id} value={ticketTypes.e_t_id}>
                          {ticketTypes.type}
                        </option>
                      ))}
                    </select>
                    {validation1.touched.e_t_id && validation1.errors.e_t_id && (
                      <div className="invalid-feedback">
                        {validation1.errors.e_t_id}
                      </div>
                    )}
                  </div>

                    {duration==1?
                      <div className='form-group mb-3 col-md-4 col-xs-12'>
                        <Grid item xs={12}>
                        <FormControl fullWidth className='custom-select datepciker position-relative'>
                          <label>Select Date :</label>
                            <DatePicker 
                                className={`form-control ${validation1.touched.date && validation1.errors.date ? "is-invalid" : ""}`} 
                                inputMode="none" 
                                isClearable id="date-picker"  
                                name="date" 
                                selected={validation1.values.date} 
                                onChange={handleDateChange} 
                                dateFormat="dd-MM-yyyy" 
                                placeholderText="DD-MM-YYYY" 
                                format="DD/MM/YYYY" 
                                minDate={new Date(Math.max(new Date().setHours(0, 0, 0, 0), new Date(eventStartDate)))}
                                maxDate={new Date(eventEndDate)}
                                autoComplete="off"
                                disableKeyboardNavigation
                            />
                            <img src={calender} className="calender-img" alt="" />
                            {validation1.touched.date && validation1.errors.date && (
                                <Typography className='lable-error'>{validation1.errors.date}</Typography>
                            )}
                        </FormControl>
                        </Grid>
                        </div>
                        :""
                    }
                  
                <div className='form-group mb-3 col-md-4 col-xs-12'>
                      <label>Quantity:</label>
                      <input
                        type='number'
                        className={`form-control ${validation1.touched.ticket_quantity && validation1.errors.ticket_quantity ? 'is-invalid' : ''}`}
                        name="ticket_quantity"
                        placeholder="Please Select Quantity"
                        value={validation1.values.ticket_quantity || ''}
                        onChange={(e) => {
                          validation1.handleChange(e);
                          // Clear seats when quantity changes
                          setSelectedSeats([]);
                          validation1.setFieldValue("selected_seats", []);
                        }}
                        min="1"
                        max="6"
                        invalid={
                        validation1.touched.ticket_quantity && validation1.errors.ticket_quantity ? true : false
                        }
                        
                    />
                    {validation1.touched.ticket_quantity && validation1.errors.ticket_quantity ? (
                        <div className="invalid-feedback" >{validation1.errors.ticket_quantity}</div>
                    ) : null}
                    </div>

                    {/* Seat Selection Section */}
                    {isSeatsRequired && (
                      <div className="form-group mb-3 col-md-12">
                        <label>Select Seats:</label>
                        <div className="seat-selection-container" style={{ border: '1px solid #ddd', padding: '15px', borderRadius: '5px', maxHeight: '300px', overflowY: 'auto' }}>
                          {availableSeats.length > 0 ? (
                            <div className="seats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(60px, 1fr))', gap: '10px' }}>
                              {availableSeats.map((seat) => (
                                <button
                                  key={seat.seat_id}
                                  type="button"
                                  className={`seat-btn ${selectedSeats.includes(seat.seat_id) ? 'selected' : ''} ${seat.is_available === 'No' ? 'booked' : 'available'}`}
                                  style={{
                                    padding: '8px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: 
                                      seat.is_available === 'No' 
                                        ? '#ff4757'
                                        : selectedSeats.includes(seat.seat_id) 
                                          ? '#2ed573' 
                                          : '#f1f2f6',
                                    color: seat.is_available === 'No' || selectedSeats.includes(seat.seat_id) ? 'white' : 'black',
                                    cursor: seat.is_available === 'No' ? 'not-allowed' : 'pointer',
                                    fontSize: '12px'
                                  }}
                                  onClick={() => seat.is_available === 'Yes' && handleSeatSelection(seat.seat_id)}
                                  disabled={seat.is_available === 'No'}
                                  title={`Seat ${seat.seat_number} - ${
                                          seat.is_available === 'Yes' 
                                            ? 'Available' 
                                            : 'Booked'
                                        }`}
                                >
                                  {seat.seat_number}
                                </button>
                              ))}
                            </div>
                          ) : (
                            <div className="text-center" style={{ padding: '20px', color: '#666' }}>
                              {validation1.values.e_id && validation1.values.e_t_id ? (
                                parseInt(duration) === 1 ? (
                                  validation1.values.date 
                                    ? 'Loading seats...' 
                                    : 'Please select a date to view seats'
                                ) : 'Loading seats...'
                              ) : (
                                parseInt(duration) === 1 
                                  ? 'Please select event, ticket type and date to view seats'
                                  : 'Please select event and ticket type to view seats'
                              )}
                            </div>
                          )}
                          
                          {selectedSeats.length > 0 && (
                            <div className="selected-seats-info" style={{ marginTop: '15px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                              <strong>Selected Seats:</strong> {selectedSeats.join(', ')}
                              <span style={{ marginLeft: '10px', color: '#666' }}>
                                ({selectedSeats.length}/{validation1.values.ticket_quantity} selected)
                              </span>
                            </div>
                          )}
                          
                          <div className="seat-legend" style={{ marginTop: '15px', display: 'flex', gap: '15px', fontSize: '12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                              <div style={{ width: '15px', height: '15px', backgroundColor: '#f1f2f6', border: '1px solid #ccc' }}></div>
                              <span>Available</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                              <div style={{ width: '15px', height: '15px', backgroundColor: '#2ed573', border: '1px solid #ccc' }}></div>
                              <span>Selected</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                              <div style={{ width: '15px', height: '15px', backgroundColor: '#ff4757', border: '1px solid #ccc' }}></div>
                              <span>Booked</span>
                            </div>
                          </div>
                        </div>
                        {validation1.touched.selected_seats && validation1.errors.selected_seats && (
                          <div className="invalid-feedback d-block" style={{ marginTop: '5px' }}>
                            {validation1.errors.selected_seats}
                          </div>
                        )}
                      </div>
                    )}

                  </div>
                  <button type='button' className='btn btn-primary me-2'
                  id="submit1"
                  onClick={(e) => {
                      e.preventDefault();
                      validation1.handleSubmit();
                      return false;
                  }}>
                  {('Assign Ticket')}
                  </button>
                  <Link to='/list-org-tickets' className='btn btn-light'>
                    Cancel
                  </Link>
                </form>
              </div>
            </div>
          </div>
        </div>
              <Modal show={showModal} onHide={handleCloseModal} centered backdrop={isProcessing ? 'static' : true} keyboard={!isProcessing}>
                <Modal.Header closeButton={!isProcessing}>
                  <Modal.Title>
                    Assign Ticket
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                      Are you sure you want to assign the Ticket to{" "}
                      <strong>
                        {username}
                      </strong>
                      ? This action cannot be undone.
                    </>
                </Modal.Body>
                <Modal.Footer>
                  <Button 
                    variant='light' 
                    onClick={handleCloseModal}
                    disabled={isProcessing}
                  >
                    Cancel
                  </Button>
                  <Button
                    id="submit2"
                    className={`btn btn-success`}
                    onClick={(e) => {
                      e.preventDefault();
                      validation1.handleSubmit();
                      return false;
                    }}
                    disabled={isProcessing}
                  >
                    {isProcessing ? 'Processing...' : 'Assign'}
                  </Button>
                </Modal.Footer>
              </Modal>
      </Fragment>
    );
};

export default AddOrgTicket;